import { createReducer } from '@reduxjs/toolkit';
import { SET_AOVIVO_NEWS } from '../actions/AovivoNewsAction';

const initialState = {
    newsData: [],
};

const aovivoNews = createReducer(initialState, (builder) => {
    builder.addCase(SET_AOVIVO_NEWS, (state, action) => {
        state.newsData = action.data;
    });
});

export default aovivoNews;
